module.exports = __webpack_public_path__ + "img/09.38db508f.png";